import axios from "axios";
import * as types from "./constants";

export const GET_USER = "GET_USER";

export const ATT_EMAIL_PROFISSIONAL = "ATT_EMAIL_PROFISSIONAL";
export const NEW_USER_PROFISSIONAL = "NEW_USER_PROFISSIONAL";
export const ATT_PASS_PROFISSIONAL = "ATT_PASS_PROFISSIONAL";
export const ATT_GERAL_PROFISSIONAL = "ATT_GERAL_PROFISSIONAL";
export const DELETE_USER_PROFISSIONAL = "DELETE_USER_PROFISSIONAL";
export const FETCH_CATEGORIAS = "FETCH_CATEGORIAS";

export const SET_VALOR_CHAT = "SET_VALOR_CHAT";
export const SET_VALOR_VIDEO = "SET_VALOR_VIDEO";
export const SET_SOBRE = " SET_SOBRE";

export const ATT_EMAIL_USER = "ATT_EMAIL_USER";
export const NEW_USER = "NEW_USER";
export const ATT_PASS_USER = "ATT_PASS_USER";
export const ATT_GERAL_USER = "ATT_GERAL_USER";
export const DELETE_USER = "DELETE_USER";
export const ADD_HABILIDADE = "ADD_HABILDIADE";
export const SET_CATEGORIA_PROFISSIONAL = "SET_CATEGORIA_PROFISSIONAL";

let usuarioTest = {
  nome: "Pedro",
  rg: "Test",
  cnpj: "Test",
  cidade: "Fortaleza",
  endereco: "Devari",
  estado: "Ceará",
  pais: "Brasil",
  telefone: "Test",
  celular: "Test",
  profissao: "Test",
  empresa: "Devari",
  email: "pedro@test.com",
  senha: "test",
  cpf: "",
  valorChat: "10",
  valorVideo: "20",
  descricaoProfissional:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In hendrerit quam diam, a luctus magna egestas id. Suspendisse sollicitudin suscipit dictum. Donec eget lobortis risus. Aliquam erat volutpat. Vivamus volutpat, dui iaculis rutrum commodo, magna lectus facilisis libero, sit amet vestibulum lorem augue non nisi. In velit orci, pulvinar vitae tellus a, tristique luctus quam. Nunc sed mi id odio viverra mollis. Etiam auctor dolor vehicula, bibendum turpis vel, sagittis turpis. Vestibulum condimentum, ligula ultricies euismod varius, enim est dictum justo, et lacinia quam velit sagittis diam. Sed bibendum eget tellus quis sollicitudin.",
  isProfessional: false,
  habilidades: [
    "Abrir Empresas",
    "Coach",
    "Head Trainer",
    "Contador",
    "Marketing"
  ],
  categoria: "Pequenas empresas",
  optionDelete: "",
  comentarioDelete: ""
};

let categorias = [
  {
    nome: "Direito",
    profissionaisTop: [],
    sub: [
      { id: "1", nome: "Direito Penal", url: "#" },
      { id: "2", nome: "Direito Administrativo", url: "#" },
      { id: "3", nome: "Direito Processual Penal", url: "#" },
      { id: "4", nome: "Direito Tributario", url: "#" }
    ]
  },
  {
    nome: "Empresarial",
    profissionaisTop: [],
    sub: [
      { id: "1", nome: "Direito Penal", url: "#" },
      { id: "2", nome: "Direito Administrativo", url: "#" },
      { id: "3", nome: "Direito Processual Penal", url: "#" },
      { id: "4", nome: "Direito Tributario", url: "#" }
    ]
  },

  {
    nome: "Contabilidade",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  },
  {
    nome: "Guia de estudos",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  },
  {
    nome: "Psicologia",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  },
  {
    nome: "Nutrição",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  },
  {
    nome: "Fotografia",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  },
  {
    nome: "Dentista",
    profissionaisTop: [],
    sub: [{ id: "1", nome: "Direito Penal", url: "#" }]
  }
];

export const fetchUser = data => {
  let user = data;
  return {
    type: GET_USER,
    payload: user
  };
};

///////////////////
// Profissional CRUD

export const attEmailProfissional = email => {
  console.log(usuarioTest.email);
  usuarioTest.email = email;

  return {
    type: ATT_EMAIL_PROFISSIONAL,
    payload: usuarioTest
  };
};

export const attPassProfissional = pass => {
  console.log(usuarioTest.email);
  usuarioTest.senha = pass;

  return {
    type: ATT_PASS_PROFISSIONAL,
    payload: usuarioTest
  };
};

export const attGeralProfissional = (nome, estado, pais) => {
  usuarioTest.nome = nome;
  usuarioTest.estado = estado;
  usuarioTest.pais = pais;

  return {
    type: ATT_GERAL_PROFISSIONAL,
    payload: usuarioTest
  };
};

export const newUserProfissional = (
  nome,
  rg,
  cnpj,
  cidade,
  endereco,
  estado,
  pais,
  telefone,
  celular,
  profissao,
  empresa,
  email,
  senha
) => {
  usuarioTest.nome = nome;
  usuarioTest.rg = rg;
  usuarioTest.cnpj = cnpj;
  usuarioTest.cidade = cidade;
  usuarioTest.endereco = endereco;
  usuarioTest.estado = estado;
  usuarioTest.pais = pais;
  usuarioTest.telefone = telefone;
  usuarioTest.celular = celular;
  usuarioTest.profissao = profissao;
  usuarioTest.empresa = empresa;
  usuarioTest.email = email;
  usuarioTest.senha = senha;
  usuarioTest.isProfessional = true;

  console.log("Cadastrado");

  return {
    type: NEW_USER_PROFISSIONAL,
    payload: usuarioTest
  };
};

export const deleteUserProfissional = (comentario, option) => {
  usuarioTest.nome = "";
  usuarioTest.rg = "";
  usuarioTest.cnpj = "";
  usuarioTest.cidade = "";
  usuarioTest.endereco = "";
  usuarioTest.estado = "";
  usuarioTest.pais = "";
  usuarioTest.telefone = "";
  usuarioTest.celular = "";
  usuarioTest.profissao = "";
  usuarioTest.empresa = "";
  usuarioTest.email = "";
  usuarioTest.senha = "";

  usuarioTest.optionDelete = option;
  usuarioTest.comentarioDelete = comentario;
  console.log("Cadastrado");

  return {
    type: DELETE_USER_PROFISSIONAL,
    payload: usuarioTest
  };
};

export const setValorChat = valor => {
  usuarioTest.valorChat = valor;
  return {
    type: SET_VALOR_CHAT,
    payload: usuarioTest
  };
};
export const setValorVideo = valor => {
  usuarioTest.valorVideo = valor;
  return {
    type: SET_VALOR_VIDEO,
    payload: usuarioTest
  };
};
export const setSobre = sobre => {
  usuarioTest.descricaoProfissional = sobre;
  return {
    type: SET_SOBRE,
    payload: usuarioTest
  };
};

export const addHabilidade = habilidade => {
  usuarioTest.habilidades.push(habilidade);
  return {
    type: ADD_HABILIDADE,
    payload: usuarioTest
  };
};
export const setCategoriaProfissional = categoria => {
  usuarioTest.categoria = categoria;
  return {
    type: SET_CATEGORIA_PROFISSIONAL,
    payload: usuarioTest
  };
};

////////////
// USER CRUD

export const attEmailUser = email => {
  console.log(usuarioTest.email);
  usuarioTest.email = email;

  return {
    type: ATT_EMAIL_USER,
    payload: usuarioTest
  };
};

export const attPassUser = pass => {
  console.log(usuarioTest.email);
  usuarioTest.senha = pass;

  return {
    type: ATT_PASS_USER,
    payload: usuarioTest
  };
};
export const attGeralUser = (nome, estado, pais) => {
  usuarioTest.nome = nome;
  usuarioTest.estado = estado;
  usuarioTest.pais = pais;

  return {
    type: ATT_GERAL_USER,
    payload: usuarioTest
  };
};

export const newUser = (
  nome,
  rg,
  cpf,
  cidade,
  endereco,
  estado,
  pais,
  telefone,
  celular,
  email,
  senha
) => {
  const url = `http://localhost:8000/api/v1/usuario/cliente/cadastrar/`;
  let ok = false;
  let request = axios
    .post(url, {
      email: email,
      password: senha,
      name: nome,
      phone: telefone,
      cell_phone: celular,
      identity_document: rg,
      cpf_cnpj: cpf,
      city: cidade,
      street: endereco,
      state: estado
    })
    .then(res => {
      console.log(res);

      if (res.status === 200) {
        ok = true;
      }
    })
    .catch(err => {
      console.log(err);
    });

  return {
    type: NEW_USER,
    payload: request
  };
};

export const deleteUser = (comentario, option) => {
  usuarioTest.nome = "";
  usuarioTest.rg = "";
  usuarioTest.cnpj = "";
  usuarioTest.cidade = "";
  usuarioTest.endereco = "";
  usuarioTest.estado = "";
  usuarioTest.pais = "";
  usuarioTest.telefone = "";
  usuarioTest.celular = "";
  usuarioTest.profissao = "";
  usuarioTest.empresa = "";
  usuarioTest.email = "";
  usuarioTest.senha = "";

  usuarioTest.optionDelete = option;
  usuarioTest.comentarioDelete = comentario;

  console.log("Cadastrado");

  return {
    type: DELETE_USER,
    payload: usuarioTest
  };
};
// new

// LOGIN
export const setLoginSuccess = data => {
  return {
    type: types.LOGIN_SUCCESS,
    payload: data
  };
};
export const setLoginError = data => {
  console.log("action", data);
  return {
    type: types.LOGIN_ERROR,
    payload: data
  };
};
export const setLogoutSuccess = data => {
  return {
    type: types.LOGOUT_SUCCESS
  };
};
// RESET PASSWORD
export const setResetPasswordSuccess = () => {
  return {
    type: types.RECOVER_PASSWORD_SUCCESS
  };
};

export const setResetPasswordError = () => {
  return {
    type: types.RECOVER_PASSWORD_FAILED
  };
};

export const cleanRecoverState = () => {
  return {
    type: types.CLEAN_RECOVER_STATE
  };
};

// CREATE ACCOUNT
export const setCreateAccountSuccess = data => {
  return {
    type: types.CREATE_ACCOUNT_SUCCESS,
    payload: data
  };
};
export const setCreateAccountError = data => {
  return {
    type: types.CREATE_ACCOUNT_ERROR,
    payload: data
  };
};
// CHANGE PASS
export const setChangePassSuccess = data => {
  return {
    type: types.CHANGE_PASS_SUCCESS,
    payload: data
  };
};
export const setChangePassError = data => {
  return {
    type: types.CHANGE_PASS_ERROR,
    payload: data
  };
};
// CHANGE ACCOUNT
export const setChangeUpdateSuccess = (message, data) => {
  return {
    type: types.UPDATE_ACCOUNT_SUCCESS,
    message,
    data
  };
};
export const cleanUpdateMsgs = () => {
  return {
    type: types.CLEAN_UPDATE_MSG
  };
};
export const setUpdateError = data => {
  return {
    type: types.SET_UPDATE_ERROR,
    payload: data
  };
};

export const setUpdateLoading = data => {
  return {
    type: types.SET_UPDATE_LOADING,
    payload: data
  };
};

// CATEGORY

export const fetchGroups = data => {
  return {
    type: types.FETCH_GROUPS,
    payload: data
  };
};

export const fetchCategories = data => {
  return {
    type: types.FETCH_CATEGORIES,
    payload: data
  };
};

export const fetchSubcategories = data => {
  return {
    type: types.FETCH_SUBCATEGORIES,
    payload: data
  };
};

// PROFESSIONA;
export const fetchProfessionals = data => {
  return {
    type: types.FETCH_PROFESSIONALS,
    payload: data
  };
};

// UTILS
export const checkLoggedUser = data => {
  return {
    type: types.CHECK_LOGIN,
    payload: data
  };
};
export function isLoading(bool) {
  return {
    type: types.LOADING,
    isLoading: bool
  };
}
export const getUserInfo = data => {
  return {
    type: types.GET_USER,
    payload: data
  };
};

// STORE STATE

export const catchCategory = data => {
  return {
    type: types.SET_CATEGORY,
    payload: data
  };
};
export const catchProfessional = data => {
  return {
    type: types.SET_PROFESSIONAL,
    payload: data
  };
};

//CONSULTS

export const addConsultAnswer = data => {
  return {
    type: types.ADD_CONSULT_REQUEST_ANSWER,
    payload: data
  };
};

export const removeConsultAnswer = data => {
  return {
    type: types.REMOVE_CONSULT_REQUEST_ANSWER,
    payload: data
  };
};

//CHATS

export const addChatNotification = data => {
  return {
    type: types.ADD_CHAT_NOTIFICATION
  };
};

export const cleanChatNotifications = () => {
  return {
    type: types.CLEAN_CHAT_NOTIFICATIONS
  };
};

export const updateChatList = (chat, chatId, lastMessage) => {
  return {
    type: types.UPDATE_CHAT_LIST,
    chat,
    chatId,
    lastMessage
  };
};

export const updateConsultStatus = (consultId, newStatus) => {
  return {
    type: types.UPDATE_CONSULT_STATUS,
    consultId,
    newStatus
  };
};

export const fetchVideochats = data => {
  return {
    type: types.FETCH_VIDEO_NOTIFICATIONS,
    payload: data
  };
};

export const removeVideochat = consultId => {
  return {
    type: types.REMOVE_VIDEO_NOTIFICATION,
    consultId
  };
};

export const fetchChats = data => {
  return {
    type: types.FETCH_CHATS,
    payload: data
  };
};

export const updateChatsWithContactData = newList => {
  return {
    type: types.UPDATE_CHATS_WITH_CONTACT_DATA,
    payload: newList
  };
};

export const updateChatWithMessages = (messages, chatRef) => {
  return {
    type: types.UPDATE_CHAT_WITH_MESSAGES,
    payload: {
      messages,
      chatRef
    }
  };
};

export const updateChatLastMessage = (chatRef, updates) => {
  return {
    type: types.UPDATE_CHAT_LAST_MESSAGE,
    payload: {
      chatRef,
      updates
    }
  };
};

export const updateChatData = (chatRef, chatData) => {
  return {
    type: types.UPDATE_CHAT_DATA,
    payload: {
      chatRef,
      chatData
    }
  };
};
